<script>
  import { mapActions } from 'vuex'

  const AUTH_API = '/api/auth'

export default {
  methods: {
    ...mapActions([
      'removeToken',
      'setLoggedRole',
      'setLoggedStatus',
      'setLoggedId',
      'setLoggedUser',
      'setLoggedUserState',
      'setPermissionMap',
      'setClientId'
    ]),
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },
    checkToken() {
      clearInterval(this.$root.monitor)
      let that = this
      this.$http.get(AUTH_API + '/isTokenValid/' + this.authenticationToken, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          if (!response.data) {
              that.logout()
          }
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка проверки токена. ')
        })
    },
    logout () {
      this.removeToken()
      this.setLoggedId(null)
      this.setLoggedUser('')
      this.setLoggedUserState('')
      this.setLoggedStatus(false)
      this.setLoggedRole('Anonymous')
      this.setPermissionMap('')
      this.setClientId(null)
      this.$router.push('/login')
    }

  }
}
</script>



// WEBPACK FOOTER //
// CheckToken.vue?667c1ee8